import React, { useState } from 'react';
import { useAdmin } from '../../context/AdminContext';
import { adminApi } from '../../api';
import { toast } from '../../hooks/use-toast';
import { Check, X, Copy } from 'lucide-react';

const statusColor = (s) => s === 'APPROVED' ? 'text-[#22c55e]' : s === 'PENDING' ? 'text-[#f59e0b]' : 'text-[#ef4444]';

const DepositsAdmin = () => {
  const { deposits, refreshAll } = useAdmin();
  const [filter, setFilter] = useState('ALL');

  const list = filter === 'ALL' ? deposits : deposits.filter((d) => d.status === filter);

  const approve = async (d) => {
    if (!window.confirm(`Approve ${d.amount} ${d.currency} for @${d.user?.username}?`)) return;
    try {
      await adminApi.approveDeposit(d.id);
      toast({ title: 'Approved', description: d.id });
      refreshAll();
    } catch (e) { toast({ title: 'Failed', description: e?.response?.data?.detail || 'Try again' }); }
  };

  const reject = async (d) => {
    const reason = window.prompt('Reject reason?', 'Invalid transaction reference');
    if (reason === null) return;
    try {
      await adminApi.rejectDeposit(d.id, reason);
      toast({ title: 'Rejected', description: d.id });
      refreshAll();
    } catch (e) { toast({ title: 'Failed', description: e?.response?.data?.detail || 'Try again' }); }
  };

  return (
    <div className="px-8 py-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <div className="text-[10px] tracking-[0.25em] text-[#5a5a5a] font-mono">DEPOSITS</div>
          <div className="text-2xl text-[#e6e6e6] font-mono">{list.length} <span className="text-[10px] text-[#5a5a5a] tracking-[0.25em]">RECORDS</span></div>
        </div>
        <div className="flex gap-1">
          {['ALL', 'PENDING', 'APPROVED', 'REJECTED'].map((f) => (
            <button key={f} onClick={() => setFilter(f)} className={`px-3 py-1.5 text-[10px] tracking-[0.2em] rounded-md border font-mono ${filter === f ? 'border-[#22c55e] text-[#22c55e] bg-[#0f1a12]' : 'border-[#1f1f1f] text-[#8a8a8a]'}`}>{f}</button>
          ))}
        </div>
      </div>

      <div className="border border-[#151515] rounded-md overflow-hidden font-mono">
        <div className="grid grid-cols-[140px_1fr_1fr_1.5fr_1fr_100px_120px] px-4 py-3 text-[10px] tracking-[0.25em] text-[#5a5a5a] border-b border-[#151515] bg-[#080808]">
          <div>DEPOSIT ID</div>
          <div>USER</div>
          <div>AMOUNT</div>
          <div>TXN REF</div>
          <div>DATE</div>
          <div className="text-right">STATUS</div>
          <div className="text-right">ACTION</div>
        </div>
        {list.length === 0 && <div className="px-4 py-8 text-center text-[12px] text-[#5a5a5a]">No deposits.</div>}
        {list.map((d) => (
          <div key={d.id} className="grid grid-cols-[140px_1fr_1fr_1.5fr_1fr_100px_120px] px-4 py-3 text-[12px] border-b border-[#0f0f0f] last:border-0 items-center hover:bg-[#0d0d0d]">
            <div className="text-[#22c55e] truncate pr-2">{d.id}</div>
            <div className="text-[#8a8a8a] truncate pr-2">@{d.user?.username || '-'}</div>
            <div className="text-[#e6e6e6]">{d.currency === 'USDT' ? '$' : '₹'}{Number(d.amount).toFixed(2)}</div>
            <div className="text-[#8a8a8a] truncate pr-2">
              <button onClick={() => { navigator.clipboard.writeText(d.txn_ref); toast({ title: 'Copied' }); }} className="inline-flex items-center gap-1 hover:text-[#22c55e]">
                <Copy size={10} /> <code className="text-[11px]">{d.txn_ref || '-'}</code>
              </button>
            </div>
            <div className="text-[#8a8a8a] text-[11px]">{d.created_at}</div>
            <div className={`text-right tracking-[0.2em] ${statusColor(d.status)}`}>{d.status}</div>
            <div className="text-right flex justify-end gap-1">
              {d.status === 'PENDING' && (
                <>
                  <button onClick={() => approve(d)} className="px-2 py-1 rounded border border-[#22c55e] text-[#22c55e] hover:bg-[#0f1a12]"><Check size={12} /></button>
                  <button onClick={() => reject(d)} className="px-2 py-1 rounded border border-[#1f1f1f] text-[#8a8a8a] hover:border-[#ef4444] hover:text-[#ef4444]"><X size={12} /></button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DepositsAdmin;
